import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Numbered list — three rows prefixed with "1.", "2.", "3." Reads
 *  as the "ordered list" counterpart to `IcnListBullet`. Numbers are
 *  drawn as inline `<text>` elements so they paint at the same stroke
 *  weight as the body lines without needing a separate font import. */
export function IcnListNumbered(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="list-numbered">
      <text x="1" y="6" fontSize="4.5" fill="currentColor" stroke="none">1.</text>
      <text x="1" y="10" fontSize="4.5" fill="currentColor" stroke="none">2.</text>
      <text x="1" y="14" fontSize="4.5" fill="currentColor" stroke="none">3.</text>
      <line x1="6" y1="4.5" x2="14" y2="4.5" />
      <line x1="6" y1="8.5" x2="14" y2="8.5" />
      <line x1="6" y1="12.5" x2="14" y2="12.5" />
    </Svg>
  );
}
